import { ContentBlock } from '@fortem-monorepo/web-sdk'

import { ContentBlockRenderer } from '@/components/content-blocks/ContentBlockRenderer'
import { DataGridBlockOverrides } from '@/components/content-blocks/blocks/data-grid/types'
import { ContentBlockContextProvider } from '@/components/content-blocks/context'

export const ContentBlocks: React.FC<{
  blocks: ContentBlock[]
  dataGridOverrides?: DataGridBlockOverrides
}> = ({ blocks, dataGridOverrides }) => {
  return (
    <ContentBlockContextProvider>
      {(context) => (
        <div className="flex flex-col gap-4">
          {blocks.map((block) => (
            <ContentBlockRenderer
              key={block.id}
              block={block}
              context={context}
              dataGridOverrides={dataGridOverrides}
            />
          ))}
        </div>
      )}
    </ContentBlockContextProvider>
  )
}
